import {
  Form,
  Input,
  Radio,
  Button,
  Modal,
  Card,
  Row,
  Col,
  DatePicker,
} from "antd";
import { useContext, useEffect, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import classes from "./RapportHomologation.module.css";
import {
  generatePdf,
  updateActionAffaire,
  updateAffaire,
  uploadDocumentAffaire,
} from "../../api/geoprod";
import { useLoader } from "../../context/LoaderContext";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axiosInstance from "../../utils/axios";

const { TextArea } = Input;

const RapportInputs = (props) => {
  const { globalData } = useContext(GlobalContext);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { idHomologation } = props;
  const { setIsLoading } = useLoader();
  const [openModalRapport, setOpenModalRappprt] = useState("");
  const [openModalDecision, setOpenModalDecision] = useState(false);
  const role = sessionStorage.getItem("role");
  const navigate = useNavigate();
  const onFinish = (values) => {
    setOpenModalDecision(true);
  };
  const headerImageUrl =
    "https://cdn.cloud.geoprod.com/static/uploads/files/logo%20MEFP.png";
  const user = JSON.parse(sessionStorage.getItem("-x-token-user"));
  const data = {
    specialite: globalData.specialite,
    niveau: "III",
    structure: globalData?.nom_etablissement,
    // date: "18-09-2013",
    operationnelle: "oui",
    correspondanceEmploi: form?.getFieldValue(
      "correspondance_definition_emploi"
    ),
    contenuProgramme: form?.getFieldValue("correspondance_modules"),
    selectionApprenants: form?.getFieldValue("selection_apprenants"),
    equipementsFormation: form?.getFieldValue("equipements_formation"),
    espacesFormation: form?.getFieldValue("espaces_formation"),
    qualificationFormateurs: form?.getFieldValue("qualification_formateurs"),
    evaluationStagiaires: form?.getFieldValue("evaluation_stages"),
    miseEnOeuvre: form?.getFieldValue("mise_en_oeuvre_formation"),
    date: dayjs(form?.getFieldValue("date_visite")).format("DD/MM/YYYY"),
  };
  useEffect(() => {
    form.resetFields();
    if (globalData?.rapportRapporteur) {
      form.setFieldsValue({
        ...globalData?.rapportRapporteur,
        date_visite: dayjs(globalData.rapportRapporteur.date_visite),
      });
    }
  }, [globalData?.rapportRapporteur]);

  const reportHtml = `
  <div style="padding: 24px; line-height: 1.6em;">
    <div style="text-align: center;">
      <img src="${headerImageUrl}" alt="Header Ministère" style="max-width: 50%;" />
    </div>
  
    <h3 style="text-align: center;">
      RAPPORT D’ÉVALUATION D’UNE DEMANDE D’HOMOLOGATION
    </h3>
  
    <p><strong>Intitulé de la spécialité :</strong> ${data.specialite}</p>
    <p><strong>Niveau demandé :</strong> 
      II ${data.niveau === "II" ? "■" : "□"} 
      III ${data.niveau === "III" ? "■" : "□"} 
      IV ${data.niveau === "IV" ? "■" : "□"}
    </p>
    <p><strong>Structure de formation :</strong> ${data.structure}</p>
    <p><strong>Date de la visite de constat :</strong> ${data.date}</p>
    <p><strong>Spécialité opérationnelle :</strong> 
      Oui ${data.operationnelle === "oui" ? "■" : "□"} 
      Non ${data.operationnelle === "non" ? "■" : "□"}
    </p>
  
    <hr />
  
    <h4>1/ La correspondance avec la définition de l’emploi dans la branche professionnelle concernée</h4>
    <p>${data.correspondanceEmploi}</p>
  
    <h4>2/ L’intitulé de la spécialité</h4>
    <p>${data.specialite}</p>
  
    <h4>3/ Le contenu du programme par rapport à la qualification visée</h4>
    <p>${data.contenuProgramme}</p>
  
    <h4>4/ Le mode et les critères de sélection des apprenants</h4>
    <p>${data.selectionApprenants}</p>
  
    <h4>5/ Les équipements de formation et les moyens didactiques</h4>
    <p>${data.equipementsFormation}</p>
  
    <h4>6/ Les espaces de formation</h4>
    <p>${data.espacesFormation}</p>
  
    <h4>7/ La qualification des formateurs</h4>
    <p>${data.qualificationFormateurs}</p>
  
    <h4>8/ Le mode d’évaluation des stagiaires</h4>
    <p>${data.evaluationStagiaires}</p>
  
    <h4>9/ La mise en œuvre de la formation</h4>
    <p>${data.miseEnOeuvre}</p>
  
    <h4 style="margin-top: 24px;">
      Recommandations à la structure de formation
    </h4>
  
    <div style="padding: 12px; border: 1px solid #ccc; margin-bottom: 24px;">
      <strong>AVIS DU RAPPORTEUR :</strong>
      <p>
        Correspondance du niveau demandé avec l’emploi ciblé : 
        Oui ${
          form.getFieldValue("correspondance_niveau") === "Oui" ? "■" : "□"
        } 
        Non ${form.getFieldValue("correspondance_niveau") === "Non" ? "■" : "□"}
      </p>
      <p>
        Favorable pour l’homologation au niveau demandé : 
        Oui ${
          form.getFieldValue("favorable_homologation") === "Oui" ? "■" : "□"
        } 
        Non ${
          form.getFieldValue("favorable_homologation") === "Non" ? "■" : "□"
        } <br />
        Sous réserve d’appliquer les recommandations du présent rapport
      </p>
    </div>
  
    <div>
      <strong>Rapport présenté par :</strong> ${user?.nom} ${user?.prenom}<br />
      <span>Le ${dayjs().format("DD/MM/YYYY HH:mm:ss")}</span>
    </div>
  </div>
  `;

  const generateReport = async (pdf, type) => {
    axiosInstance
      .get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/v0/load_list_document_affaire/${idHomologation}`,
        {
          headers: {
            Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then(async (res) => {
        const nbRapports = res?.data?.filter(
          (e) =>
            e.md5_id ===
            import.meta.env.VITE_APP_ID_TYPE_DOC_RAPPORT_RAPPORTEUR_HOMOLOGATION
        )[0]?.files?.length;
        const pdfFile = await fetch(pdf);
        const blob = await pdfFile.blob();
        const formData = new FormData();
        formData.append("id_affaire", idHomologation);
        formData.append(
          "id_type_doc",
          import.meta.env.VITE_APP_ID_TYPE_DOC_RAPPORT_RAPPORTEUR_HOMOLOGATION
        );
        formData.append("name_doc", `Rapport_homologation_v${nbRapports + 1}`);
        formData.append(
          "file[]",
          blob,
          `Rapport_homologation_v${nbRapports + 1}.pdf`
        );

        const payload = {
          additional_form: "{}",
          json_prod: {
            ...globalData,
            rapportRapporteur: {
              ...form.getFieldsValue(),
            },
          },
        };
        const resposneUpdateAffaire = updateAffaire(
          idHomologation,
          payload,
          "rapport"
        );
        if (resposneUpdateAffaire) {
          const data = await uploadDocumentAffaire(formData);
          if (data) {
            const payload = {
              id_affaire: idHomologation,
              id_status:
                type === "favorable"
                  ? import.meta.env
                      .VITE_APP_ID_STATUS_DECISION_RAPPORTEUR_VALIDE
                  : import.meta.env
                      .VITE_APP_ID_STATUS_DECISION_RAPPORTEUR_REFUSEE,
            };

            const data = await updateActionAffaire(payload);
            if (data) {
              setIsLoading(false);
              navigate("/demandes");
            }
          }
        }
      });
  };

  const onSelect = async (type) => {
    setIsLoading(true);
    setOpenModalDecision(false);
    if (type !== "dossier") {
      const pdf = await generatePdf(reportHtml);
      if (pdf) {
        generateReport(pdf?.data?.file_url, type);
      }
    } else {
      const payload = {
        id_affaire: idHomologation,
        id_status: import.meta.env
          .VITE_APP_ID_STATUS_DECISION_RAPPORTEUR_DOSSIER_MANQUANT,
      };
      const payloadUpdateAffaire = {
        additional_form: "{}",
        json_prod: {
          ...globalData,
          rapportRapporteur: {
            ...form.getFieldsValue(),
          },
        },
      };
      const resposneUpdateAffaire = updateAffaire(
        idHomologation,
        payloadUpdateAffaire,
        "rapport"
      );
      if (resposneUpdateAffaire) {
        const data = await updateActionAffaire(payload);
        if (data) {
          setIsLoading(false);
          navigate("/demandes");
        }
      }
    }
  };

  return (
    <Card
      title="Avis rapporteur"
      style={{
        margin: "1rem",
      }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        disabled={role !== "rapporteur"}
      >
        <Row gutter={16}>
          <Col lg={24}>
            <Form.Item
              label="Correspondance avec la définition de l’emploi dans la branche professionnelle concernée"
              name="correspondance_definition_emploi"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Contenu du programme par rapport à la qualification visée"
              name="correspondance_modules"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Le mode et les critères de sélection des apprenants"
              name="selection_apprenants"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Mode d’évaluation des stagiaires"
              name="evaluation_stages"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Qualification des formateurs"
              name="qualification_formateurs"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Équipements de formation et moyens didactiques"
              name="equipements_formation"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="Espaces de formation"
              name="espaces_formation"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={24}>
            <Form.Item
              label="La mise en œuvre de la formation"
              name="mise_en_oeuvre_formation"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <TextArea rows={1} />
            </Form.Item>
          </Col>

          <Col lg={12}>
            <Form.Item
              label="Favorable pour l’homologation au niveau demandé"
              name="favorable_homologation"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <Radio.Group>
                <Radio value="Oui">Oui</Radio>
                <Radio value="Non">Non</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col lg={12}>
            <Form.Item
              label="Correspondance du niveau demandé avec l’emploi ciblé"
              name="correspondance_niveau"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <Radio.Group>
                <Radio value="Oui">Oui</Radio>
                <Radio value="Non">Non</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col lg={12}>
            <Form.Item
              label="Date de visite"
              name="date_visite"
              rules={[{ required: true, message: "Ce champ est obligatoire." }]}
            >
              <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
            </Form.Item>
          </Col>

          {role === "rapporteur" && (
            <Col lg={24} style={{ display: "flex", justifyContent: "end" }}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  {t("Décision")}
                </Button>
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
      <Modal
        title="Prise de décision"
        open={openModalDecision}
        onCancel={() => setOpenModalDecision(false)}
        footer={null}
        centered
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="decision"
            label="Choisissez une décision"
            rules={[
              { required: true, message: "Veuillez sélectionner une option." },
            ]}
            className={classes.decisionButtons}
          >
            <Button
              className={classes.decisionButton}
              style={{ backgroundColor: "#2bbbad" }}
              onClick={() => onSelect("favorable")}
            >
              Avis favorable
            </Button>
            <Button
              className={classes.decisionButton}
              style={{ backgroundColor: "#e74c3c" }}
              onClick={() => onSelect("defavorable")}
            >
              Avis défavorable
            </Button>
            <Button
              className={classes.decisionButton}
              style={{ backgroundColor: "#fbbc04" }}
              onClick={() => onSelect("dossier")}
            >
              Dossier manquant
            </Button>
          </Form.Item>

          {/* <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Soumettre
            </Button>
          </Form.Item> */}
        </Form>
      </Modal>
    </Card>
  );
};

export default RapportInputs;
